var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';

export default function withTimer(Component) {
  var _class, _temp2;

  return _temp2 = _class = function (_PureComponent) {
    _inherits(Timer, _PureComponent);

    function Timer() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Timer);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Timer.__proto__ || Object.getPrototypeOf(Timer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        remainingTime: 0
      }, _this.startTimer = function (remainingTime) {
        clearInterval(_this.timer);
        _this.timer = setInterval(_this.tick, 1000);
        _this.setState({ remainingTime: remainingTime });
      }, _this.stopTimer = function () {
        clearInterval(_this.timer);
        _this.setState({ remainingTime: 0 });
      }, _this.tick = function () {
        var remainingTime = _this.state.remainingTime - 1;
        if (remainingTime <= 0) {
          _this.stopTimer();
        } else {
          _this.setState({ remainingTime: remainingTime });
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Timer, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        clearInterval(this.timer);
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(Component, _extends({}, this.props, {
          remainingTime: this.state.remainingTime,
          startTimer: this.startTimer,
          stopTimer: this.stopTimer
        }));
      }
    }]);

    return Timer;
  }(PureComponent), _class.displayName = 'withTimer(' + (Component.displayName || Component.name || 'Component') + ')', _temp2;
}